import { Box, Paper, Typography } from "@mui/material";
import { EmpreendimentoMap } from "./empreendimentoMap";
import { BibliotecaBarragem } from "../biblioteca";
import { CalendarioBarragem } from "../calendario";

export const Barragem: React.FC = () => {
  return (
    <Box sx={{
      flex: 1,
      margin: 0,
      padding: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      overflow: 'hidden',
      flexDirection: 'row',
    }}>
      {/* Calendário e biblioteca */}
      <Box sx={{
        flex: 2,
        p: "0.5em",
        gap: "0.5em",
        display: "flex",
        flexDirection: "column",
      }}>
        <Paper elevation={0} sx={{
          flex: 1,
          p: "0.5em",
          gap: "0.5em",
          height: "50%",
          display: "flex",
          flexDirection: "column",
          boxSizing: 'border-box',
        }} >
          <Typography fontWeight={550} fontSize={14} color='secondary.main'>
            Calendário da Barragem
          </Typography>
          <CalendarioBarragem />
        </Paper>

        <Paper elevation={0} sx={{
          flex: 1,
          p: "0.5em",
          gap: "0.5em",
          height: "50%",
          display: "flex",
          flexDirection: "column",
          boxSizing: 'border-box',
        }} >
          <BibliotecaBarragem />
        </Paper>
      </Box>

      {/* Mapa */}
      <Paper elevation={0} sx={{
        flex: 3,
        width: '100%',
        height: '100%',
        paddingY: "0.5em",
        paddingRight: "0.5em",
        paddingLeft: "0.25em",
        boxSizing: 'border-box',
      }} >
        <EmpreendimentoMap />
      </Paper>
    </Box>
  );
};
